/* src/app/core/layout/breadcrumb/breadcrumb.component.scss */
/*# sourceMappingURL=breadcrumb.component.css.map */
